import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const DEMO = [
  { label: "Fleet Manager", email: "manager@fleetlio.demo", pw: "Demo1234!" },
  { label: "Auditor", email: "auditor@fleetlio.demo", pw: "Demo1234!" },
  { label: "Viewer", email: "viewer@fleetlio.demo", pw: "Demo1234!" },
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e?: React.FormEvent, em = email, pw = password) => {
    e?.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(em, pw);
      nav("/");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen tg-grid-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md tg-enter">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-xl bg-blue-500/15 border border-blue-500/30 flex items-center justify-center shadow-[0_0_20px_rgba(59,130,246,0.35)]"><ShieldCheck className="h-6 w-6 text-blue-400" /></div>
          <div>
            <h1 className="font-display text-3xl font-semibold tracking-tight">Fleetlio</h1>
            <p className="tg-label">Fleet audit control room · Europe/London</p>
          </div>
        </div>
        <form onSubmit={submit} className="tg-card p-6 space-y-4" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-slate-300">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[#0f141f] border-[#26334d] font-mono text-sm" placeholder="you@fleet.co.uk" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-slate-300">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-[#0f141f] border-[#26334d] font-mono text-sm" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/20 rounded px-3 py-2">{error}</div>}
          <Button data-testid="login-submit-button" type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-500 text-white">{busy ? "Signing in…" : "Sign in"}</Button>
          <div className="pt-2 border-t border-[#26334d]">
            <div className="tg-label mb-2">Demo mode · instant sign-in</div>
            <div className="grid grid-cols-3 gap-2">
              {DEMO.map((d) => (
                <Button key={d.email} type="button" variant="outline" size="sm" data-testid={`demo-login-${d.label.toLowerCase().replace(" ", "-")}-button`} onClick={() => submit(undefined, d.email, d.pw)} className="border-[#26334d] bg-transparent text-slate-300 hover:bg-[#182030] text-xs">{d.label}</Button>
              ))}
            </div>
          </div>
        </form>
        <p className="text-center text-xs text-slate-500 mt-6">Telemetry gateway: Traccar (hidden) · Provider: {"SIMULATED"} in demo</p>
      </div>
    </div>
  );
}
